const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export function mediaUrl(path) {
  if (!path) return null;
  return `${BACKEND}${path}`;
}
